<template>
    <div>
        <button class="request__quote__header" v-b-modal.my-modal-header>Request Quote / Contact Us</button>
        <b-modal id="my-modal-header" ref="modal" title="REQUEST A QUOTE" @shown="removeClass" @show="resetModal" @hidden="resetModal" @ok="handleOk" size="lg" :ok-title="this.okTitle" :busy="this.busy">
            <form ref="form" @submit.stop.prevent="handleSubmit" class="request-form">
                <div class="row">
                    <div class="col-sm-6 required">
                        <b-form-group :state="nameState" label="Name" label-for="name-input"
                                        :invalid-feedback="this.formErrors.name">
                            <b-form-input id="name-input" v-model="name" :state="nameState"></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-sm-6 required">
                        <b-form-group :state="emailState" label="Email"  label-for="email-input"
                                        :invalid-feedback="this.formErrors.email">
                            <b-form-input id="email-input" v-model="email" :state="emailState"
                                            type="email"></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-sm-6 ">
                        <b-form-group label="Phone" label-for="phone-input">
                            <b-form-input id="name-input" v-model="phone"></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-sm-6">
                        <b-form-group label="Company" label-for="company-input">
                            <b-form-input id="name-input" v-model="company"></b-form-input>
                        </b-form-group>
                    </div>

                    <div class="col-sm-12 ">
                        <b-form-group label="Address" label-for="address-input">
                            <b-form-textarea id="textarea" v-model="address" rows="3"
                                                max-rows="6"></b-form-textarea>
                        </b-form-group>
                    </div>
                    <div class="col-sm-12 required">
                        <b-form-group label="Description" :state="descriptionState" :invalid-feedback="this.formErrors.description" label-for="description-input">
                            <b-form-textarea id="textarea" :state="descriptionState" v-model="description" rows="3" max-rows="6" placeholder="Please tell us about your project."></b-form-textarea>
                        </b-form-group>
                    </div>

                    <div class="col-sm-12">
                        <label class="custom-file-label mb-0" for="validatedCustomFile">Choose File</label>
                        <div class="form-group col-sm-12" v-if="!image">
                            <input type="file" class="custom-file-input " id="validatedCustomFile"
                                    @change="onFileChange">
                        </div>

                        <div class="form-group" v-else>
                            <label>{{image.name}}</label>
                            <button @click="removeImage" class="btn btn-danger py-2 px-3">Remove image</button>
                        </div>
                    </div>

                    <div class="col-sm-12 text-end">
                        <b-button variant="danger" d-inline-block @click="$bvModal.hide('my-modal-header')" class="btn">Cancel</b-button>
                        <button d-inline-block class="g-recaptcha ms-1 btn btn-primary" :data-sitekey="siteKey" data-callback='onSubmit' data-action='submit' data-size="invisible" variant="primary">{{ okTitle }}</button>
                    </div>


                </div>
            </form>
        </b-modal>
    </div>
</template>


<script>

    import axios from 'axios';
    import BootstrapVue from 'bootstrap-vue'
    import VueToast from 'vue-toast-notification';
    import 'bootstrap-vue/dist/bootstrap-vue.css'
    import 'vue-toast-notification/dist/index.css';

    Vue.use(VueToast);

    Vue.use(BootstrapVue);

    export default {
        props: [
            'type',
            'id',
            'variant',
            'item',
            'session',
        ],
        data: function () {
            return {
                name: '',
                nameState: null,
                email: '',
                emailState: null,
                company: '',
                description: '',
                descriptionState: null,
                address: '',
                phone: '',
                image: null,
                busy: false,
                gRecaptchaResponse: null,
                okTitle: 'Submit',
                formErrors: {
                    name: null,
                    email: null,
                    description: null,
                    recaptcha: null,
                },
                isNotDescription: true,
            }
        },
        methods: {
            removeImage: function (e) {
                this.image = '';
            },
            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                this.createImage(files[0]);
            },
            createImage(file) {

                var image = new Image();

                var reader = new FileReader();

                var vm = this;

                // reader.onload = (e) => {
                //     vm.image = e.target.result;
                // };


                reader.onload = function (e) {
                    vm.image = {
                        name: file.name,
                        data: e.target.result,
                        type: file.type,
                        size: file.size
                    };
                };


                reader.readAsDataURL(file);
            },
            // onVerify(response) {
            //     this.gRecaptchaResponse = response;
            // },
            checkFormValidity() {
                const valid = this.$refs.form.checkValidity()
                this.nameState = valid ? 'valid' : 'invalid'
                this.emailState = valid ? 'valid' : 'invalid'
                this.descriptionState = valid ? 'valid' : 'invalid'
                return valid
            },
            resetModal() {
                this.name = '',
                this.nameState = null,
                this.email = '',
                this.emailState = null,
                this.company = '',
                this.description = '',
                this.descriptionState = null,
                this.address = '',
                this.phone = '',
                this.image = null,
                this.okTitle = 'Submit',
                this.busy = false,
                this.gRecaptchaResponse = null;
                this.formErrors = {
                    name: null,
                    email: null,
                    description: null,
                    recaptcha: null,
                }
            },
            removeClass(){
                document.getElementById('my-modal-header').classList.remove('fade');
            },
            handleOk(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault()
                // Trigger submit handler
                this.handleSubmit()
            },
            handleSubmit() {
                let that = this;
                this.okTitle = "Submitting"
                this.busy = true;
                grecaptcha.ready(function() {
                    grecaptcha.execute(that.siteKey, {action: 'submit'}).then(function(token) {
                        axios.post(that.url + '/request', {
                            name: that.name,
                            email: that.email,
                            company: that.company,
                            description: that.description,
                            phone: that.phone,
                            address: that.address,
                            type: that.type,
                            id: that.id,
                            image: that.image,
                            item: that.item,
                            session_id: that.session,
                            g_recaptcha_response: token,
                            ga4_session_id: window.ga4_session_id,
                        }).then(function (response) {
                                Vue.$toast.open({
                                    message: response.data,
                                    type: "success",
                                    duration: 5000,
                                    dismissible: true
                                })
                                that.$nextTick(() => {
                                    that.$refs.modal.hide()
                                })
                            }).catch(function (error) {
                                that.nameState = null;
                                that.formErrors.name = null;
                                that.emailState = null;
                                that.formErrors.email = null;
                                that.descriptionState = null;
                                that.formErrors.description = null;
                                that.okTitle = "Submit";
                                that.busy = false;
                                if (error.response.data.errors.name) {
                                    that.nameState = false;
                                    that.formErrors.name = error.response.data.errors.name[0];
                                } else {
                                    that.nameState = true;
                                }
                                if (error.response.data.errors.email) {
                                    that.emailState = false;
                                    that.formErrors.email = error.response.data.errors.email[0];
                                } else {
                                    that.emailState = true;
                                }
                                if (error.response.data.errors.description) {
                                    that.descriptionState = false;
                                    that.formErrors.description = error.response.data.errors.description[0];
                                } else {
                                    that.descriptionState = true;
                                }
                                if (error.response.data.errors.g_recaptcha_response) {
                                    that.formErrors.recaptcha = error.response.data.errors.g_recaptcha_response[0];
                                }
                            });
                        });
                    });


            } 
        },
       
        computed: {
            url: function () {
                return process.env.MIX_API_URL;
            },
            baseUrl: function () {
                return window.location.href;
            },
            segment: function () {
                return window.location.href.substring(window.location.href.lastIndexOf('/') + 1)
            },
            classObject: function () {
                return {
                    'pro-btn-center': this.isNotDescription,
                }
            },
            siteKey: function () {
                console.log(process.env.MIX_GOOGLE_RECAPTCHA_KEY);
                return process.env.MIX_GOOGLE_RECAPTCHA_KEY;
            },

        },

    }
</script>
